import { QuickTipsTranslation } from '@/assets/locales/views/candidates/details/quickTips/quickTips.translation.en.ts';

export const quickTipsTranslation: QuickTipsTranslation = {
  feedbackTip:
    ' Po analizie CV, udziel konstruktywnej informacji zwrotnej. Podkreśl mocne strony, omów słabości i wspomnij o wszelkich obawach. Może to pomóc kandydatom poprawić ich przyszłe aplikacje i ukierunkować decyzje rekrutacyjne.',
  quickTips: 'Quick Tips',
  redFlagsTip:
    'Zwracaj uwagę na sygnały ostrzegawcze w CV, takie jak częste zmiany pracy, niewyjaśnione luki czy niespójności w informacjach. Mogą one wskazywać na potencjalne problemy, które wymagają dalszego zbadania.',
  strengthsTip:
    'Szukaj pozytywnych cech kandydata, takich jak odpowiednie umiejętności, osiągnięcia i doświadczenie, które odpowiadają wymaganiom stanowiska. Wskazują one na ich potencjał do odniesienia sukcesu w danej roli.',
  weaknessesTip:
    'Zidentyfikuj obszary, w których kandydat może brakować niezbędnych umiejętności lub doświadczenia. Może to obejmować luki w zatrudnieniu lub niewystarczające kwalifikacje. Zrozumienie słabości może pomóc ocenić ich dopasowanie do stanowiska.',
};
